<span [ngSwitch]="synced">
    <icc-icon *ngSwitchCase="'synced'" name="file_synced"></icc-icon>
    <icc-icon *ngSwitchCase="'syncing'" name="file_synchronization"></icc-icon>
    <icc-icon *ngSwitchCase="'offline'" name="file_offline_only"></icc-icon>
    <icc-icon *ngSwitchCase="'online'" name="file_online_only"></icc-icon>
    <icc-icon *ngSwitchCase="'download'" name="file_download"></icc-icon>
</span>